import {
  Backdrop,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Step,
  StepLabel,
  Stepper,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import axiosInstance from "../../api/axiosInstance";
import { useThunk } from "../../hooks/useThunk";
import { getExperienceInvitation } from "../../store/thunks/experience/getExperienceInvitation";
import { getExperienceRegistration } from "../../store/thunks/experience/getExperienceRegistration";
import { extractDateTime } from "../utils/extractDateTime";
import { extracDeadLineTime } from "../utils/extractDeadLineTime";
import { useTranslation } from "react-i18next";
import { capitalizeFirstLetter } from "../utils/capitalizerLetter";
import { getExperiencePayment } from "../../store/thunks/experience/getExperiencePayment";
import PersonalInfoGroup from "../profile/web/PersonalInfoGroup";
import { qrCode } from "../../store/thunks/user/qrCode";
import { useSelector } from "react-redux";
import BookOnlineOutlinedIcon from '@mui/icons-material/BookOnlineOutlined';



const QrCodeDialog = ({ open, onClose}) => {

  const [getQrCode, isLoadingQrCode, errorQrCode] = useThunk(qrCode);
  const { profileQrCode } = useSelector((state) => state.user);
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // The QR code carries a check-in token valid 60 minutes: fetch a fresh one each
  // time the pass is opened, and renew it while it stays open.
  useEffect(() => {
    if (!open) return undefined;
    getQrCode();
    const renew = setInterval(() => getQrCode(), 50 * 60 * 1000);
    return () => clearInterval(renew);
  }, [open]);
  return (
    <Dialog
      open={open}
      onClose={onClose}
      
      fullScreen={isMobile}
    >
      <DialogTitle
        sx={{
          fontWeight: "bold",
          fontSize: isMobile ? "1.2rem" : "1.5rem", 
          color: "text.accent"
        }}
      >
        <BookOnlineOutlinedIcon/> Experiment pass
      </DialogTitle>
      <Divider />
      <Typography sx={{padding: "1em"}}>Present this QrCode and your Student card when arriving at the experiment laboratory.</Typography>
      <DialogContent sx={{ p: isMobile ? 2 : 3, display: "flex", justifyContent:"center" }}>
       {profileQrCode && <img
        src={profileQrCode}
        alt="QR code"
        style={{
          display: "flex",
          width: "160px",
          height: "160px",
          objectFit: "contain",
          borderRadius: "8px",
        }}
      />}
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: "end",
          p: isMobile ? 2 : 3,
          flexDirection: isMobile ? "column" : "row", 
          mb:isMobile ? 10 : 0
        }}
      >
        <Button
          onClick={onClose}
          color="error"
          variant="outlined"
          sx={{
            fontSize: isMobile ? "0.8rem" : "1rem", 
            width: isMobile ? "100%" : "auto", 
            mb: isMobile ? 3 : 0, 
          }}
        >
          {t("close")}
        </Button>
       
      </DialogActions>

      {isLoadingQrCode && (
        <Backdrop
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: 1201,
            color: "#fff",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
          }}
          open={true}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
    </Dialog>
  );
};

export default QrCodeDialog;
